<template>
	<transition
		@enter="handleCardOpen"
		:css="false"
	>
		<div
			data-name="splash-screen-start-card"
			:class="[$style.wrapper]"
			ref="mainWrapper"
		>
			<div
				ref="cardWrapper"
				:class="[
          $style.cardWrapper,
          {
              [$style.residential]: buildingType === 'residential'
          },
          {
              [$style.commercial]: buildingType === 'commercial'
          }
        ]"
			>
				<div :class="$style.cardContentWrapper">
					<div :class="[$style.cardTitleContainer, {
            [$style.residentialCardTitle]: buildingType === 'residential'
          }, {
            [$style.commercialCardTitle]: buildingType === 'commercial'
          }]">{{ title }}</div>
					<div
						v-if="text"
						:class="[$style.cardTextContainer, {
            [$style.residentialCardText]: buildingType === 'residential'
          }, {
            [$style.commercialCardText]: buildingType === 'commercial'
          }]"
					>{{ text }}</div>
				</div>
				<div :class="[
            $style.startButtonWrapper, {
              [$style.residentialStartWrapper]: buildingType === 'residential'
            },
            {
              [$style.commercialStartWrapper]:  buildingType === 'commercial'
            }]">
					<UiButton
						:class="$style.startButton"
						buttonText="Get Started"
						:buttonAction="() => {}"
					></UiButton>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import UiButton from "./UiButton";
// import vClickOutside from 'v-click-outside';
import isMobileMixin from "../plugins/isMobileMixin.js";
import tweenSpeedsMixin from "../plugins/tweenSpeedsMixin.js";
import { TweenMax, TimelineMax } from "gsap";

export default {
	name: "splash-screen-start-card",
	mixins: [isMobileMixin, tweenSpeedsMixin],
	components: {
		UiButton
	},
	props: {
		title: {
			type: String,
			required: true
		},
		text: {
			type: String,
			required: true
		},
		buildingType: {
			type: String,
			required: true
		}
	},
	// directives: {
	//     clickOutside: vClickOutside.directive
	// },
	data() {
		return {};
	},
	watch: {},
	mounted() {
		console.log("lk;asjdfkjsdf");
		this.elsToAnim = [this.$refs.mainWrapper];

		this.$bus.$on("intro-hover-on", this.handleHoverOn);
		this.$bus.$on("intro-hover-off", this.handleHoverOff);
		this.$bus.$on("fade-out-get-started", this.fadeOutGetStarted);
	},
	methods: {
		handleHoverOn(type) {
			const thisStartEl =
				this.buildingType === "commercial"
					? "." + this.$style.residentialStartWrapper
					: "." + this.$style.commercialStartWrapper;
			if (this.buildingType === type) {
				// hide start button
				TweenMax.to(thisStartEl, 0.1, {
					opacity: 0,
					y: 10
				});
			} else {
				// show start button
				TweenMax.to(thisStartEl, 0.5, {
					opacity: 1,
					y: 0,
					delay: 0.1,
					ease: Power4.easeOut
				});
			}
			// show darker gradient

			// start button
		},
		handleHoverOff(type) {
			if (this.buildingType !== type) return;
			// hide darker gradient
		},
		handleCardOpen(el, done) {
			// debugger;
		},
		handleStartClick() {
			if (this.buildingType === "residential") {
				this.$router.to("/residential");
			}
			if (this.buildingType === "commercial") {
				this.$router.to("/commercial");
			}
		},
		fadeIntroductionIn() {
			TweenMax.staggerFromTo(
				this.elsToAnim,
				this.tweenSpeeds.dur.itemFadeIn,
				{
					opacity: 0
				},
				{
					opacity: 1,
					delay: 1.25,
					y: "0%",
					onComplete: () => {
						TweenMax.set(this.$refs.mainWrapper, {
							pointerEvents: "auto",
							zIndex: 300
						});
					},
					ease: this.tweenSpeeds.ease.global
				},
				this.tweenSpeeds.dur.staggerDiff
			);
		},
		fadeIntroductionOut() {
			TweenMax.staggerFromTo(
				this.elsToAnim,
				this.tweenSpeeds.dur.itemFadeIn,
				{
					opacity: 1
				},
				{
					opacity: 0,
					onComplete: () => {
						TweenMax.set(this.$refs.mainWrapper, {
							pointerEvents: "none",
							zIndex: -1
						});
					}
				},
				this.tweenSpeeds.dur.staggerDiff
			);
		},
		fadeOutGetStarted() {
			TweenMax.to("." + this.$style.startButtonWrapper, 0.5, {
				autoAlpha: 0
			});
		}
	},
	beforeDestroy() {
		this.$bus.$off("intro-hover-on", this.handleHoverOn);
		this.$bus.$off("intro-hover-off", this.handleHoverOff);
	}
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
	// width: 100%;
	// height: 50%;

	display: flex;
	justify-content: center;
	flex-direction: column;
	// align-items: flex-end;

	z-index: 800;

	cursor: pointer;

	text-align: center;
}

.card-wrapper {
	position: relative;
	// width: 100%;

	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-direction: column;

	// padding: 30px;
	// padding-top: 100px;
}

.residential {
	// background-color: #a4ae04;

	// background: rgba(0, 0, 0, 0.75);
	// background: linear-gradient(
	// 	0deg,
	// 	rgba(0, 0, 0, 0.7) 0%,
	// 	rgba(0, 0, 0, 0.2) 65%,
	// 	rgba(0, 0, 0, 0.05) 85%,
	// 	rgba(255, 255, 255, 0) 100%
	// );
}

.commercial {
	// background-color: #509fdd;

	// background: rgba(0, 0, 0, 0.75);
	// background: linear-gradient(
	// 	0deg,
	// 	rgba(0, 0, 0, 0.7) 0%,
	// 	rgba(0, 0, 0, 0.2) 65%,
	// 	rgba(0, 0, 0, 0.05) 85%,
	// 	rgba(255, 255, 255, 0) 100%
	// );
}

.card-content-wrapper {
	display: flex;
	justify-content: flex-start;
	align-items: flex-start;
	flex-direction: column;

  // width: 70%
  opacity: 1;

	color: white;
	font-weight: bold;
}

.card-title-container {
	// margin-bottom: 10px;
	background: rgba(0, 0, 0, 0.65);
	padding: 16px;
	border-radius: 20px;
	font-weight: bold;
	font-size: 14px;

  @include large {
    font-size: 18px;
    margin-bottom: 20px;
    padding: 20px;
  }
}

.card-text-container {
	line-height: 1;
	font-size: 14px;
}

.start-button-wrapper {
	// position: absolute;
	// right: 0;

	display: flex;
	justify-content: center;
	align-items: center;

	height: 45px;

	// margin-right: 30px;

	opacity: 0;
}

.residential-start-wrapper {
	content: "";
}

.commercial-start-wrapper {
	content: "";
}

.start-button {
	color: white;
	padding-left: 40px;
	padding-right: 40px;

	font-weight: bold;
}

.residential-card-title,
.commercial-card-title,
.residential-card-text,
.commercial-card-text {
	content: "";
}
</style>



// WEBPACK FOOTER //
// src/components/SplashScreenStartCard.vue